export default function ($translate) {
    return {
        KEYS: {
            NEVER: 'NEVER',
            OTHER: 'OTHER'
        },
        LABELS: {
            NEVER: $translate.instant('course.expiration.Never'),
            OTHER: $translate.instant('course.expiration.Other')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/expiration/index.js